/**
 * @generated SignedSource<<3bd6c7c858e59863bace96af2df9000b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OSType = "FreeBSD" | "Linux" | "Solaris" | "Unix" | "Unknown" | "Windows" | "macOS";
export type AgentsPagesNativeAgentTypesQuery$variables = {
  skip?: boolean | null | undefined;
};
export type AgentsPagesNativeAgentTypesQuery$data = {
  readonly agentTypes?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly agentPool: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly rawId: string;
        };
        readonly cloudImage: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly environment: {
          readonly os: {
            readonly type: OSType;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly isCloud: boolean;
        readonly name: string | null | undefined;
        readonly rawId: string;
      };
    }>;
  } | null | undefined;
};
export type AgentsPagesNativeAgentTypesQuery = {
  response: AgentsPagesNativeAgentTypesQuery$data;
  variables: AgentsPagesNativeAgentTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCloud",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "CloudImage",
  "kind": "LinkedField",
  "name": "cloudImage",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AgentEnvironment",
  "kind": "LinkedField",
  "name": "environment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OS",
      "kind": "LinkedField",
      "name": "os",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentsPagesNativeAgentTypesQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentTypesConnection",
            "kind": "LinkedField",
            "name": "agentTypes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*:: as any*/),
                      (v2/*:: as any*/),
                      (v3/*:: as any*/),
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentPool",
                        "plural": false,
                        "selections": [
                          (v1/*:: as any*/),
                          (v2/*:: as any*/),
                          (v3/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AgentsPagesNativeAgentTypesQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentTypesConnection",
            "kind": "LinkedField",
            "name": "agentTypes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*:: as any*/),
                      (v2/*:: as any*/),
                      (v3/*:: as any*/),
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentPool",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          (v1/*:: as any*/),
                          (v2/*:: as any*/),
                          (v3/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*:: as any*/),
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2fd09e99108821ee64ed7f6600a18142",
    "id": null,
    "metadata": {},
    "name": "AgentsPagesNativeAgentTypesQuery",
    "operationKind": "query",
    "text": "query AgentsPagesNativeAgentTypesQuery(\n  $skip: Boolean = true\n) {\n  agentTypes @skip(if: $skip) {\n    edges {\n      node {\n        id\n        rawId\n        name\n        isCloud\n        agentPool {\n          __typename\n          id\n          rawId\n          name\n        }\n        cloudImage {\n          id\n          name\n        }\n        environment {\n          os {\n            type\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de3585e8249fc7c6ae5a2474696c187d";

export default node;
